import React from "react";

import { mdiWeatherNight, mdiWeatherSunny } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";

import { useTheme } from "@/src/contexts/ThemeContext";

import type { JSX } from "react";

function ThemeToggle(): JSX.Element {
  const { resolvedTheme, setPreference } = useTheme();
  const isDark = resolvedTheme === "dark";

  const iconClassName = classNames(
    "cursor-pointer text-primary-foreground/50 transition-colors hover:text-primary-foreground",
  );

  return (
    <button
      aria-label="Basculer le thème"
      className="flex items-center border-0 bg-transparent p-0"
      onClick={() => setPreference(isDark ? "light" : "dark")}
      type="button"
    >
      <Icon
        className={iconClassName}
        path={isDark ? mdiWeatherSunny : mdiWeatherNight}
        size={1}
      />
    </button>
  );
}

export default ThemeToggle;
